import { isFoodSoldOut } from "../utils/order";

const useFood = (foodDetails) => {
    return {
        isFoodSoldOut: isFoodSoldOut(foodDetails)
    }
};

export default useFood;